import React from 'react';
import {
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    EditButton,
    SimpleForm,
    TextInput,
    SelectField,
    BooleanInput,
    NumberInput
} from 'react-admin';

import { required, maxLength, minLength } from './../../utils/validations';

export const CityList = (props) => (
    <List {...props} title="Cities" bulkActionButtons={false}>
        <Datagrid>
            <TextField source="name" label="Name" />
            <TextField source="state" label="State" />
            <TextField source="country" label="Country" />
            <SelectField source="enabled" label="Enabled" choices={choices} />
            <EditButton />
        </Datagrid>
    </List>
);

const CityTitle = ({ record }) => {
    return <span>City {record ? `"${record.name}"` : ''}</span>;
};

const choices = [
    { id: true, name: 'Yes' },
    { id: false, name: 'No' }
];

const validateName = [required(), minLength(2), maxLength(15)];

export const CityEdit = (props) => (
    <Edit title={<CityTitle />} {...props} redirect="list" >
        {createUpdateForm}
    </Edit>
);

const createUpdateForm = <SimpleForm redirect="list">
    <TextInput label="Name" source="name" validate={validateName} />
    <TextInput label="State" source="state" validate={validateName} />
    <TextInput label="Country" source="country" validate={validateName} />
    <TextInput label="Contact Person Name" source="contactName" />
    <TextInput label="Contact Person Mobile No" source="contactNumber" />
    <TextInput label="Contact Person Email" source="contactEmail" />
    <TextInput label="Pincodes" source="pincodes" />
    <TextInput label="Banner Images" source="bannerImageUrls" />
    <TextInput label="PayTM Merchant ID (Payment Gateway)" source="paytmMerchantID" />
    <TextInput label="PayTM Secret-Key (Payment Gateway)" source="paytmSecretKey" />
    <TextInput label="UPI Payee VPA" source="upiPayeeVpa" />
    <TextInput label="UPI Payee Name" source="upiPayeeName" default="Zadish - Food Delivery Services" />
    <TextInput label="Android App Version" source="appVersionName" />
    <NumberInput
        label="Distance for Normal Delivery (In Meters)"
        source="distanceForNormalDelivery"
        defaultValue={3000} />
    <NumberInput
        label="Default Latitude"
        source="defaultLatitude"
        defaultValue={0} />
    <NumberInput
        label="Default Longitude"
        source="defaultLongitude"
        defaultValue={0} />
    <BooleanInput
        label="Cab Booking"
        source="cabBooking"
        validate={required()}
        defaultValue={false} />
    <BooleanInput
        label="PayTM Payment Enabled"
        source="paytmPaymentEnabled"
        validate={required()}
        defaultValue={false} />
    <BooleanInput
        label="UPI Payment Enabled"
        source="upiPaymentEnabled"
        validate={required()}
        defaultValue={false} />
    <BooleanInput
        label="Cash On Delivery Enabled"
        source="cashOnDeliveryEnabled"
        validate={required()}
        defaultValue={true} />
    <BooleanInput
        label="Enabled"
        source="enabled"
        validate={required()}
        defaultValue={false} />
</SimpleForm>;

export const CityCreate = (props) => (
    <Create {...props} redirect="list">
        {createUpdateForm}
    </Create>
);